// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { getAnalysis, getAnalysisRunSnapshot } from '../../../services/AnalysisApiClient';
import { isServerBackedAnalysisId } from '../../../utils/isServerBackedAnalysisId';
import { Analysis } from '../workflow/CompanyApp';
import { InfoBanner } from '../components/WorkflowFormPrimitives';
import { WorkspaceLoadingCard } from '../../shared/WorkspaceLoadingCard';

/**
 * Loads and renders a stored 280G run snapshot (read-only workflow + results).
 * Use from {@link RunSnapshotSlideOver}, client `/client/run-history/:analysisId/:runId`, or any host shell.
 */
export default function RunSnapshotView({ analysisId, runId, headerAction = null }) {
  const aid = String(analysisId ?? '').trim();
  const rid = String(runId ?? '').trim();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [workflowData, setWorkflowData] = useState(null);
  const [analysisResults, setAnalysisResults] = useState(null);
  const [capturedAt, setCapturedAt] = useState(null);
  const [analysisName, setAnalysisName] = useState('280G Analysis');

  useEffect(() => {
    if (!isServerBackedAnalysisId(aid) || !isServerBackedAnalysisId(rid)) {
      setError('Invalid analysis or run.');
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);
    setAnalysisName('280G Analysis');
    getAnalysis(aid)
      .then((a) => {
        const name = String(a?.name ?? '').trim();
        if (name) setAnalysisName(name);
      })
      .catch((e) => {
        console.warn('Could not load analysis name for snapshot header', e);
      });

    getAnalysisRunSnapshot(aid, rid)
      .then((body) => {
        if (!body?.workflowData || !Array.isArray(body.analysisResults)) {
          setError('This run has no stored snapshot, or the snapshot is incomplete.');
          setWorkflowData(null);
          setAnalysisResults(null);
          setCapturedAt(null);
          return;
        }
        setWorkflowData(body.workflowData);
        setAnalysisResults(body.analysisResults);
        setCapturedAt(body.capturedAtISO ?? null);
      })
      .catch((e) => {
        console.error(e);
        setError(e instanceof Error ? e.message : 'Failed to load snapshot');
      })
      .finally(() => setLoading(false));
  }, [aid, rid]);

  return (
    <div className="space-y-5">
      {error ? (
        <InfoBanner variant="danger" showIcon>
          {error}
        </InfoBanner>
      ) : null}

      {loading ? (
        <WorkspaceLoadingCard
          title="Loading snapshot…"
          description="Fetching stored inputs and results for this run."
          ariaLabel="Loading run snapshot"
        />
      ) : null}

      {!loading && workflowData && analysisResults ? (
        <Analysis
          formData={workflowData}
          snapshotMode
          snapshotResults={analysisResults}
          snapshotCapturedAt={capturedAt}
          analysisTitle={analysisName}
          headerAction={headerAction}
        />
      ) : null}
    </div>
  );
}
